export function buildListQuery({
  page = 1,
  limit = 15,
  filters = [],
  sort = [],
} = {}) {
  return new URLSearchParams({
    page: String(page),
    start: String((page - 1) * limit),
    limit: String(limit),
    filter: JSON.stringify(filters, (key, value) =>
      key === "operator" ? String(value).toUpperCase() : value
    ),
    sort: JSON.stringify(sort),
  }).toString();
}
